import * as React from 'react'
import './backDrop.scss'
export default class Backdrop extends React.Component<any, any> {
    render() {
        return (
            <div className="backdrop" onClick={this.props.close} />
        )
    }
}
